import React from "react";

import StopWatch from "./components/stopWatch";

function App() {
  return (
    <div className="container">
      <StopWatch />
    </div>
  );
}

export default App;
